exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".-InformationIcon-helperTextIcon-14ax2 {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n", ""]);

// exports
exports.locals = {
	"helperTextIcon": "-InformationIcon-helperTextIcon-14ax2"
};